// src/components/RevenueImpactChart.js
import React, { useRef, useEffect } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { px } from "framer-motion";

const RevenueImpactChart = () => {
  const chartRef = useRef(null);

  const data = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Courses 1",
        data: [20, 30, 25, 35, 40, 30, 45],
        borderColor: "#6a0dad",
        fill: false,
        tension: 0.4,
      },
      {
        label: "Courses 2",
        data: [30, 20, 35, 25, 30, 35, 89],
        borderColor: "#e5383b",
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Disable the default legend
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false, // Remove the grid lines
        },
        ticks: {
          color: ["#6a0dad"], // Custom colors for the labels
        },
      },
      y: {
        display: true,
        beginAtZero: true,
        grid: {
          display: false, // Remove the grid lines
        },
        ticks: {
          color: "#6a0dad", // Custom colors for the labels
        },
      },
    },
  };

  return (
    <div className="w-full h-full p-2">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-16 font-bold">Revenue Impact over 6 months</h3>
        <div id="legend-container" className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <span
              className="w-4 h-4 rounded-full"
              style={{ backgroundColor: "#EA8F95" }}
            ></span>
            <span className="text-14 font-bold text-[#EA8F95]">Courses 1</span>
          </div>
          <div className="flex items-center space-x-2">
            <span
              className="w-4 h-4 rounded-full"
              style={{ backgroundColor: "#6a0dad" }}
            ></span>
            <span className="text-14 text-[#6a0dad] font-bold">Courses 2</span>
          </div>
        </div>
      </div>
      <div className="relative w-full h-[280px]">
        <Line ref={chartRef} data={data} options={options} />
      </div>
    </div>
  );
};

export default RevenueImpactChart;
